import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  gap: 12px;
  padding-top: 20px;
`
export const SectionOne = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  gap: 12px;
`
export const SectionOneItem = styled.div`
  flex: 0 0 auto;
  min-width: fit-content;
  height: 82px;
  box-sizing: border-box;
  padding: 10px 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  background: #ffffff;
  border: 1px solid #e4ebf2;
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(31, 52, 77, 0.06);

  button {
    min-height: 32px;
    margin: 0 0 0 auto;
    padding: 6px 10px !important;
    font-size: 12px !important;
    white-space: nowrap;
  }

  @media (max-width: 640px) {
    flex: 1 1 220px;
  }
`

export const KpiIcon = styled.div<{ color: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  color: ${(props) => props.color};
  background: ${(props) => `${props.color}16`};
`

export const KpiText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  text-align: left;
  white-space: nowrap;
`
export const SectionOneItemNumber = styled.span`
  font-weight: 800;
  color: #2d749c;
  font-size: 24px;
  line-height: 1.1;
`
export const SectionOneItemDescription = styled.p`
  width: auto;
  max-width: none;
  min-height: 0;
  margin: 3px 0 0;
  color: #536b84;
  font-size: 12px;
  line-height: 1.25;

  @media (max-width: 1156px) {
    font-size: 12px;
  }
`
export const SectionTwo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
  width: 100%;

  @media (max-width: 900px) {
    flex-wrap: wrap;
  }

  @media (max-width: 600px) {
    flex-direction: column;
  }
`
export const SectionTwoPair = styled.div`
  display: flex;
  flex-direction: row;
  width: auto;
  height: 79px;
  left: 0px;
  top: 0px;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 9px;
  margin-right: 36px;
`
export const SectionTwoPairContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
export const SectionTwoIndividual = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 173px;
  height: 77px;
  left: 359px;
  top: 1px;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 9px;
`

export const CardTitle = styled.div`
  width: 67px;
  height: 18px;

  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 18px;

  text-align: left;

  color: #1f2124;
  margin-bottom: 5px;
`

export const HorizontalDivider = styled.hr`
  display: none;
`
export const Description = styled.span`
  width: 40px;
  font-size: 12;
  color: #797a7c;
`
export const ImgContainer = styled.div`
  width: 51px;
  height: 51px;
  padding: 10px;
  border-radius: 8px;
  margin-right: 10px;
`
export const SectionTwoIndividualContainer = styled.div`
  display: flex;
  flex-direction: row;
`
export const CardDescription = styled.div`
  margin: 5px;
`

interface IRow {
  height?: string
  width?: string
  justifyContent?: string
}

export const Row = styled.div<IRow>`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || 'auto'};
`
export const CompaniesTableContainer = styled.section`
  width: 100%;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(280px, 350px) auto;
  grid-template-rows: auto auto;
  align-items: center;
  column-gap: 12px;
  row-gap: 12px;
  margin-top: 18px;
  padding: 16px 12px 12px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 8px 22px rgba(31, 52, 77, 0.08);

  > .companies-toolbar {
    grid-column: 2;
    grid-row: 1;
    width: 100%;
  }

  > .companies-table {
    grid-column: 1 / -1;
    grid-row: 2;
  }

  @media (max-width: 900px) {
    grid-template-columns: minmax(0, 1fr) auto;

    > .companies-toolbar {
      grid-column: 1 / -1;
      grid-row: 2;
    }

    > .companies-table {
      grid-row: 3;
    }
  }
`

export const CompaniesTableHeading = styled.div`
  display: contents;

  > a {
    grid-column: 3;
    grid-row: 1;
    display: flex;

    button {
      margin: 0;
    }
  }

  @media (max-width: 900px) {
    > a {
      grid-column: 2;
    }
  }
`

export const CompaniesTableTitle = styled.h2`
  grid-column: 1;
  grid-row: 1;
  margin: 0;
  color: #1f344d;
  font-family: 'Public Sans', sans-serif;
  font-size: 26px;
  font-weight: 800;
  line-height: 1.2;
`
// ACTIONS

export const ContainerActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  gap: 24px;
  width: 100%;
  padding: 0;
`

export const TextViewMore = styled.p`
  // public sans font
  font-family: 'Public Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  color: #c6016b;
  cursor: pointer;
`

export const EditContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`

export const TextEdit = styled.p`
  font-family: 'Public Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  color: #2d749c;
  cursor: pointer;
  margin-right: 10px;
  margin-left: 10px;
`

interface IContainer {
  margin?: string
  bgColor?: string
  width?: string
}

export const CardContainer = styled.div<IContainer>`
  display: flex;
  flex-direction: row;
  width: 210px;
  height: 82px;
  background-color: ${(props) => props.bgColor || '#FFFFFF'};
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border: 1px solid #e4ebf2;
  border-radius: 12px;
  overflow: hidden;
`

export const ImageContainer = styled.div<IContainer>`
  width: 48px;
  flex: 0 0 48px;
  height: 100%;
  background-color: ${(props) => props.bgColor || '#81ACC4'};
  display: flex;
  justify-content: center;
  align-items: center;
`

interface IImage {
  disabled?: boolean
}

export const Image = styled.img<IImage>`
  filter: ${(props) => (props.disabled ? 'grayscale(100%)' : 'grayscale(0%)')};
  max-width: 48px;
  max-height: 48px;
  object-fit: contain;
`

export const TextContainer = styled.div`
  width: auto;
  flex: 1;
  height: 100%;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  background-color: #fbfbfb;
`

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 4px;
`

export const Title = styled.h3`
  font-weight: 700;
  font-size: 15px;
  line-height: 16px;
  color: #000000;
  margin: 0px;
`

export const SubTitle = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #000000;
  margin: 0px;
`

export const TestCardValue = styled.span`
  color: #2d749c;
  font-size: 22px;
  font-weight: 800;
  line-height: 1;
`

export const ActionContainer = styled.div`
  width: 100%;
  height: 50%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`
